import React, { FC } from 'react';
import { UserStatusOnClickWrapper } from '@/userStatus/components';

export interface IHamiUserBalanceMaskProps {
  refetch: () => {};
  showBalance: boolean;
  setShowBalance: (__value: boolean) => void;
}

const HamiUserBalanceMask: FC<IHamiUserBalanceMaskProps> = ({
  refetch,
  showBalance,
  setShowBalance,
}) => {
  return (
    <>
      {!showBalance && (
        <UserStatusOnClickWrapper>
          <button
            className="flex h-8 w-[100px] items-center justify-center rounded-md border border-solid border-gray-20 text-xxs font-regular"
            id="home_click_showHamiBalance"
            onClick={() => {
              setShowBalance(true);
              refetch();
            }}
          >
            مشاهده موجودی
          </button>
        </UserStatusOnClickWrapper>
      )}
    </>
  );
};
export { HamiUserBalanceMask };
